export default __webpack_public_path__ + "static/media/Nordstorm.5c09bfea.png";